/**
 * Storyblok option / single-select fields are usually strings but can arrive as
 * `{ value: string }` from the Content API or Visual Editor.
 */
export function resolveStoryblokStringOption(raw: unknown): string {
    if (raw == null || raw === '') {
        return '';
    }
    if (typeof raw === 'string') {
        return raw;
    }
    if (typeof raw === 'object' && raw !== null && 'value' in raw) {
        const v = (raw as { value: unknown }).value;
        if (typeof v === 'string') {
            return v;
        }
    }

    return String(raw);
}
